import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationResidenceStudyTodoApiService } from './organization-residence-study-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResidenceStudyTodoApiService extends GeneratedOrganizationResidenceStudyTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
